module.exports = __webpack_public_path__ + "static/media/facebook-red.36ad8439.svg";